<template>
    <div class="c-panel c-panel--border c-panel--expand margin-b-24">
        <div class="row margin-b-8">
            <div class="columns">
                <h3 class="margin-b-4">Berichten</h3>
            </div>
            <div class="columns shrink">
                <span class="flex flex-align-center">
                    <svg width="18" height="18" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="color-dark-gray margin-r-8"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.7838 13.0885C4.66659 13.0131 4.53052 12.973 4.38954 12.973C4.31167 12.973 4.23298 12.9869 4.15675 13.0115L2.40511 13.5967L2.98872 11.8426C3.05921 11.6328 3.03134 11.4041 2.91249 11.2164C1.95265 9.69262 1.72314 7.8377 2.28298 6.12623C2.842 4.41393 4.12396 3.0541 5.79937 2.39426C7.47396 1.73443 9.33954 1.85574 10.9141 2.72541C12.4887 3.59672 13.5846 5.11148 13.9199 6.88115C14.2543 8.65082 13.7863 10.4607 12.6379 11.8467C11.4904 13.2311 9.80183 14.0246 8.00511 14.0246H7.99691C6.85675 14.0238 5.74609 13.7 4.7838 13.0885M13.9494 3.43115C12.5395 1.5959 10.3174 0.5 8.00429 0.5C7.99855 0.50082 7.99364 0.50082 7.98626 0.5C6.23052 0.5 4.52232 1.12131 3.1756 2.25082C1.82724 3.38279 0.916586 4.96229 0.612487 6.69672C0.310848 8.41311 0.620684 10.1885 1.4838 11.7025L0.541176 14.5279C0.452651 14.791 0.523143 15.0869 0.719045 15.2828C0.859209 15.4246 1.04609 15.5 1.23872 15.5C1.31741 15.5 1.39609 15.4877 1.47314 15.4623L4.29773 14.5189C6.29118 15.6549 8.74527 15.809 10.869 14.9311C13.0092 14.0451 14.6445 12.1803 15.2445 9.9418C15.8445 7.7041 15.3592 5.26967 13.9494 3.43115" fill="currentColor"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M8.83341 8.00008C8.83341 9.11119 7.16675 9.11119 7.16675 8.00008C7.16675 6.88897 8.83341 6.88897 8.83341 8.00008" fill="currentColor"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M6.33341 8.00008C6.33341 9.11119 4.66675 9.11119 4.66675 8.00008C4.66675 6.88897 6.33341 6.88897 6.33341 8.00008" fill="currentColor"></path> <path fill-rule="evenodd" clip-rule="evenodd" d="M9.66675 8.00008C9.66675 6.88897 11.3334 6.88897 11.3334 8.00008C11.3334 9.11119 9.66675 9.11119 9.66675 8.00008Z" fill="currentColor"></path></svg>
                    {{count}}
                </span>
            </div>
        </div>
        <p class="fs-small">
            Heb je vragen of opmerkingen? Stuur een bericht in het berichtencentrum.
        </p>
        <router-link class="c-btn c-btn--secondary c-btn--hollow c-btn--small no-margin" :to="route">Open berichtencentrum</router-link>
    </div>
</template>

<script>
export default {
    props: {
        route: {
            type: Object,
            required: true
        },
        count: {
            type: Number,
            default: 0
        }
    }
}
</script>
